import { useSelector } from 'react-redux';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Icon from '../Shared/Icon';

const SystemIcons = (props) => {
    const theme = useTheme();
    const sysconfig = useSelector(state => state.sysconfig);
    const systems = sysconfig?.data?.map(x => x.SystemKey)

    const handleSystemChange = (e, value) => {
        props.changed({ target: { name: 'system', value: value } })
    };
    return (
        <ToggleButtonGroup
            onChange={handleSystemChange}
            value={props.filter.system}
            exclusive={props.exclusive}
            className="SystemIcons"
            sx={{
                flexWrap: 'wrap',
                border: 'none',
                '.MuiButtonBase-root': { border: 'none' },
                '.MuiDisabled .MuiAvatar-root .MuiAvatar-img': { opacity: 0.5 },
                '& .Mui-selected': {
                    outline: `1px solid ${theme.palette.primary.main}`,
                    borderRadius: '1rem',
                    background: theme.palette.offwhite.main//'white'
                }
            }}
        >
            {sysconfig?.data?.map((item, index) => {
                return (
                    <Tooltip
                        key={index}
                        title={item.Name}
                        arrow
                        placement="bottom"
                        enterDelay={750}
                        slotProps={{
                            popper: {
                                modifiers: [{
                                    name: 'offset',
                                    options: {
                                        offset: [0, -14],
                                    },
                                }]
                            }
                        }}
                    >
                        <ToggleButton

                            value={item.SystemKey}
                            color='primary'
                            sx={{
                                '.MuiAvatar-root': {
                                    width: '1.5rem',
                                    height: '1.5rem'
                                }
                            }}
                        >
                            <Icon system={item.SystemKey} />
                        </ToggleButton>
                    </Tooltip>

                )
            })}
        </ToggleButtonGroup>
    )
}

export default SystemIcons;